import React from "react";
import MainPageLayout from "../../components/layouts/MainPageLayout";
import { Footer } from "../landing/Footer";
import { PlayerDetails } from "./PlayerDetails";
import { TeamDetails } from "./TeamDetails";
import Fixtures from "../fixtures/Fixtures";
import { LeaderboardMain } from "./LeaderboardMain";

const PublicLeaderboard: React.FC = () => {
  return (
    <MainPageLayout Footer={<Footer />}>
      <LeaderboardMain />
    </MainPageLayout>
  );
};

export default PublicLeaderboard;

export const PublicPlayerDetails: React.FC = () => {
  return (
    <MainPageLayout Footer={<Footer />}>
      <PlayerDetails />
    </MainPageLayout>
  );
};

export const PublicTeamDetails: React.FC = () => {
  return (
    <MainPageLayout Footer={<Footer />}>
      <TeamDetails />
    </MainPageLayout>
  );
};

export const PublicFixtures: React.FC = () => {
  return (
    <MainPageLayout Footer={<Footer />}>
      <Fixtures />
    </MainPageLayout>
  );
};
